<div class="financeiro-page">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div>
      <h1>Gerar CNAB — Santander</h1>
      <p class="text-muted small mb-0">
        Gera apenas o arquivo de remessa <strong>.txt</strong> para envio ao banco.
        <a routerLink="/configuracao-cnab-santander">Configuração</a>
        ·
        <a routerLink="/importar-retorno-cnab">Importar retorno (.RET)</a>
        ·
        <a routerLink="/gerar-boleto">Gerar boleto (impressão)</a>
      </p>
    </div>
  </div>

  <div class="card-box mb-3 filtros-cnab">
    <div class="row g-2 mb-2">
      <div class="col-md-3">
        <label class="form-label">Documento</label>
        <select class="form-control form-control-sm" [(ngModel)]="filtroIdFinDocumento">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let d of documentos" [ngValue]="d.id">{{ d.descricao }}</option>
        </select>
      </div>
      <div class="col-md-5">
        <label class="form-label">Pago por</label>
        <input
          type="text"
          class="form-control form-control-sm"
          [(ngModel)]="filtroNomePagador"
          placeholder="Digite o nome do pagador"
        />
      </div>
    </div>

    <p class="filtros-data-periodos__legenda small text-muted mb-2">Períodos (opcional)</p>
    <div class="row g-2 filtros-data-periodos mb-2">
      <div class="col-lg-4 col-md-6">
        <div class="filtro-data-grupo">
          <div class="filtro-data-grupo__titulo">Emissão</div>
          <div class="row g-1">
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Inicial</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataEmissaoInicio" />
            </div>
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Final</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataEmissaoFim" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="filtro-data-grupo">
          <div class="filtro-data-grupo__titulo">Vencimento</div>
          <div class="row g-1">
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Inicial</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataVencimentoInicio" />
            </div>
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Final</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataVencimentoFim" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="filtro-data-grupo">
          <div class="filtro-data-grupo__titulo">Recebimento</div>
          <div class="row g-1">
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Inicial</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataRecebimentoInicio" />
            </div>
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Final</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataRecebimentoFim" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-2">
      <div class="col-md-3">
        <label class="form-label">Tipo recebimento</label>
        <select class="form-control form-control-sm" [(ngModel)]="filtroIdTipoRecebimento">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let t of tiposRecebimento" [ngValue]="t.id">{{ t.descricao }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">CNAB enviado</label>
        <select class="form-control form-control-sm" [(ngModel)]="filtroCnabEnviado">
          <option [ngValue]="'T'">Todos</option>
          <option [ngValue]="'S'">Sim</option>
          <option [ngValue]="'N'">Não</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Observações</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filtroObservacao" />
      </div>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-2">
      <button type="button" class="btn btn-primary btn-sm" [disabled]="loading" (click)="carregar()">
        <i class="fa fa-search"></i> Buscar
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limparFiltros()">
        <i class="fa fa-eraser"></i> Limpar filtros
      </button>
    </div>
    <p class="text-muted small mb-0 mt-2">
      Para gerar remessa, selecione títulos <strong>ativos, não pagos e sem boleto gerado</strong> (o banco valida os mesmos critérios).
    </p>
  </div>

  <div class="card-box table-wrap">
    <div *ngIf="loading && !itens.length" class="text-muted py-3">Carregando...</div>

    <div class="table-actions-left" *ngIf="itens.length || !loading">
      <button type="button" class="btn btn-success btn-sm" [disabled]="!selecionados.size" (click)="gerarRemessa()">
        <i class="fa fa-download"></i> Gerar remessa
      </button>
    </div>

    <div class="table-responsive" *ngIf="itens.length || !loading">
      <table class="table table-striped table-sm table-hover align-middle mb-0">
        <thead>
          <tr>
            <th class="col-check">
              <input type="checkbox" [checked]="todosDaPaginaSelecionados" (change)="toggleTodosPagina()" title="Selecionar página" />
            </th>
            <th>#</th>
            <th>CNAB</th>
            <th>Nosso nº</th>
            <th>Pago por</th>
            <th>Emissão</th>
            <th>Vencimento</th>
            <th>Valor título</th>
            <th>Documento</th>
            <th>Tipo recebimento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!itensPaginados.length && !loading">
            <td colspan="10" class="text-center text-muted py-3">Nenhuma conta a receber encontrada.</td>
          </tr>
          <tr
            *ngFor="let item of itensPaginados; let i = index"
            [ngClass]="item.cnabEnviado ? 'linha-cnab-enviado' : (item.previsaoReal === 'P' ? 'linha-previsao' : 'linha-real')">
            <td class="col-check">
              <input type="checkbox" [checked]="isSelecionado(item.id)" (change)="toggleSelecionado(item.id)" />
            </td>
            <td>{{ (paginaAtual - 1) * itensPorPagina + i + 1 }}</td>
            <td>
              <span class="cnab-status-badge" [ngClass]="item.cnabEnviado ? 'is-enviado' : 'is-pendente'">
                {{ item.cnabEnviado ? 'Enviado' : 'Pendente' }}
              </span>
            </td>
            <td>{{ item.nossoNumero || '-' }}</td>
            <td>{{ item.usuarioPagador || '-' }}</td>
            <td>{{ item.dataEmissao }}</td>
            <td>{{ item.dataVencimento }}</td>
            <td>{{ formatMoney(item.valorDocumento) }}</td>
            <td>{{ item.finDocumento || '-' }}</td>
            <td>{{ item.tipoRecebimento || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-bar d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3" *ngIf="itens.length">
      <span class="text-muted small">
        {{ itens.length }} registro(s) — página {{ paginaAtual }} de {{ totalPaginas }}
        <span *ngIf="selecionados.size"> — {{ selecionados.size }} selecionado(s)</span>
      </span>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <label class="small mb-0">Por página</label>
        <select class="form-control form-control-sm" style="width: 72px" [(ngModel)]="itensPorPagina" (ngModelChange)="alterarItensPorPagina()">
          <option [ngValue]="10">10</option>
          <option [ngValue]="15">15</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
        </select>
        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual <= 1" (click)="paginaAnterior()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual >= totalPaginas" (click)="proximaPagina()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
